var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M21 21v-4h2v6H7V7h5v2H9v12zm2-6.922-2.34-2.393c-1.177 1.244-2.298 2.43-3.38 3.571l-2.434-2.435c1.105-1.093 2.252-2.226 3.483-3.445L15.922 7H23z"
})));
export default SvgExternalLink;